import { create } from 'zustand';
import { QualifyingAnswers } from '../utils/lead-queue-utils';

type QualifyingAnswersState = {
  answers: QualifyingAnswers;
  setAnswer: (questionId: string, answerText: string) => void;
  clearAnswers: () => void;
};

export const useQualifyingAnswersState = create<QualifyingAnswersState>((set) => ({
  answers: {},
  setAnswer: (questionId, answerText) =>
    set((state) => ({
      answers: { ...state.answers, [questionId]: answerText },
    })),
  clearAnswers: () => set({ answers: {} }),
}));
